var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-main',[_c('v-container',[_c('v-row',[_c('v-col',[_c('h4',{staticClass:"text-h4 text-center"},[_vm._v(" Offline... Please check internet connection ")])])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }